import * as user from '../actions/user.actions';
import { UserState } from '../user.state';

const initialState: UserState = {
    name: null,
    email: null,
    userId: null,
    loggedIn: false,
    branch: null,
    oci: false,
    rights: []
};

export const userReducer = (state: UserState = initialState,
                                action) => {
    switch (action.type) {
        case user.ActionTypes.USER_UPDATE:
            return {...state, ...action.payload};
        case user.ActionTypes.LOGGED_IN_UPDATE:
            return {...state, loggedIn: action.payload};
        case user.ActionTypes.PREFERRED_BRANCH_UPDATE:
            return {...state, branch: action.payload};
        case user.ActionTypes.RIGHTS_UPDATE:
            return {...state, rights: [...action.payload]};
        default:
            return state;
    }
};
